import styled from 'styled-components';
import { Button, Flexbox, TextField, Typography } from '@hiiretail/synergy-ui';

export const StyledTextarea = styled(TextField)`
  margin-bottom: ${({ last }: { last?: boolean }) => (last ? '32px' : '16px')};
`;

export const SearchButton = styled(Button)`
  width: 100px;

  :disabled {
    background-color: #eed1fe;
  }
`;

export const SearchWrapper = styled(Flexbox)`
  > * {
    min-width: 0;
    overflow-wrap: break-word;
  }
`;

export const LeftWrapper = styled(Flexbox)`
  flex-basis: 30%;
`;

export const RightWrapper = styled(Flexbox)`
  flex-basis: 60%;
`;

export const DataRow = styled(Flexbox)`
  margin-bottom: ${({ theme }) => theme.spacing(5)}px;
`;

export const LeftColumn = styled(Typography)`
  font-weight: 500;
  flex-basis: 100px;
  color: #616161;
`;

export const RightColumn = styled(Typography)`
  flex-basis: calc(100% - 100px);
  color: #212121;
`;

export const LastRow = styled(Flexbox)`
  padding-top: 18px;
`;

export const NoSearchText = styled(Typography)`
  color: #9e9e9e;
`;

export const IdleContainer = styled(Flexbox)`
  padding-bottom: 48px;
`;

export const SvgContainer = styled.svg`
  margin-bottom: 16px;
`;

export const ErrorContainer = styled(Flexbox)`
  padding-bottom: 48px;
`;

export const EmptyFieldsMessage = styled(Flexbox)`
  margin-bottom: 16px;
`;

export const WarningIcon = styled(Flexbox)`
  flex-basis: 24px;
`;

export const EmptyFieldsText = styled(Typography)`
  flex-basis: calc(100% - 32px);
`;
